package com.clany.backoffice.model

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class SubscriptionPlanResponse(
    val id: String,
    val name: String,
    val sortOrder: Int = 0,
    val subscriptionPrice: SubscriptionPriceDto? = null,
    val description: SubscriptionTextDto? = null,
    val limits: Map<String, JsonElement> = emptyMap(),
    val features: Map<String, Boolean> = emptyMap()
)

@Serializable
data class SubscriptionPriceDto(
    val price: Float? = null,
    val currency: String = "",
    val period: String = "",
    val offerPrice: Float? = null,
    val offerActive: Boolean = false,
    val offerLabel: Map<String, String>? = null,
    val offerEndDate: String? = null
)

@Serializable
data class SubscriptionTextDto(
    val key: String,
    val value: String
)
